<template>
  <v-container>
    <v-row class="pa-0 justify-end">
      <v-col cols="10" class="d-flex justify-center pa-0 mb-n3">
        <div class="svg div" v-for="i in maxRate" :key="'rate_' + i">{{ i - 1 }}</div>
      </v-col>
    </v-row>
    <v-row class="pa-0">
      <v-col cols="2" class="col-label d-flex align-center pa-0">
        <label>{{ title }}</label>
      </v-col>
      <v-col cols="10" class="d-flex align-center justify-center pa-0">
        <svg class="svg" v-for="i in maxRate" :key="i">
          <circle
            :cx="circlePosition"
            cy="11"
            :r="circleSize"
            stroke="black"
            stroke-width="2"
            fill="white"
            @click="select_(i - 1)"
            :class="{ selected: selected == i - 1 }"
          />
        </svg>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'RateTenComponent',
  props: {
    value: Number,
    title: String,
  },
  computed: {
    circlePosition() {
      return this.$vuetify.breakpoint.smAndUp ? '11' : '6'
    },

    circleSize() {
      return this.$vuetify.breakpoint.smAndUp ? '10' : '5'
    },
  },
  data() {
    return {
      selected: null,
      maxRate: 11,
    }
  },
  methods: {
    select_(i) {
      this.selected = i
      this.$emit('input', this.selected)
    },
  },
  mounted() {
    this.selected = this.value
  },
}
</script>

<style scoped>
.col-label {
  /* border: solid 1px #000; */
  height: 60px;
}

.col-label label {
  font-size: 16px;
  line-height: 16px;
}

.svg {
  /* border: 1px solid black; */
  height: 24px;
  width: 24px;
  margin: 2px;
}
.svg.div {
  font-size: 17px;
  /* border: 1px solid black; */
  display: inline-block;
  text-align: center;
  padding: 0px;
}
.svg circle {
  cursor: pointer;
}
.svg circle:hover {
  cursor: pointer;
  fill: rgb(187, 187, 216);
}
.svg .selected {
  fill: rgb(42, 42, 141);
}
.svg .selected:hover {
  fill: rgb(42, 42, 141);
}
</style>
